export default {
  name: 'Toronto Global Forum',
  shortName: 'Toronto',
  description:
    'The Toronto Global Forum was launched in 2006 and gathers international thought leaders across business, government and civil society to discuss the major challenges, and subsequent opportunities, the world economy is facing today.',
  thumbnail: '/images/events/toronto/thumbnail-toronto.jpg',
  link: 'https://www.torontoglobalforum.com/',
  header: {
    content:
      'The Toronto Global Forum was launched in 2006 and gathers international thought leaders across business, government and civil society to discuss the major challenges, and subsequent opportunities, the world economy is facing today.'
  },
  bullets: {
    bullet1: {
      number: '17th',
      label: 'Edition'
    },
    bullet2: {
      number: '2 500+',
      label: 'In-Person Participants'
    },
    bullet3: {
      number: '140+',
      label: 'Speakers'
    },
    bullet4: {
      number: '65+',
      label: 'Represented Countries'
    }
  },
  about: {
    title: 'Our Purpose',
    content:
      'The Toronto Global Forum acts as a platform where organisations and institutions can connect with a focus on potential partnerships, investment opportunities and future collaboration. As countries and industries seek ways to enhance environmental and economic resilience and foster societal development, the conference aims to explore these topics through an international lens.'
  },
  next: {
    title: 'Fostering Economic Resilience',
    content:
      'At a time of great uncertainty worldwide, the conference will examine how we can adapt in order to encourage innovation and resilience in light of world events and the current economic climate. Join world leaders and decision makers at the Fairmont Royal York Hotel on October 11-13th 2023 for three days of dynamic discussion and debate surrounding the key topics of our time, while enjoying a variety of networking opportunities including luncheons and cocktail receptions.'
  },
  gallery: {
    title: 'Photo gallery',
    index: [
      {
        title: '16th edition — Charting a new economy',
        images: [
          '/images/events/toronto/gallery/16th-toronto-001.jpg',
          '/images/events/toronto/gallery/16th-toronto-002.jpg',
          '/images/events/toronto/gallery/16th-toronto-003.jpg',
          '/images/events/toronto/gallery/16th-toronto-004.jpg',
          '/images/events/toronto/gallery/16th-toronto-005.jpg',
          '/images/events/toronto/gallery/16th-toronto-006.jpg',
          '/images/events/toronto/gallery/16th-toronto-007.jpg',
          '/images/events/toronto/gallery/16th-toronto-008.jpg',
          '/images/events/toronto/gallery/16th-toronto-009.jpg'
        ]
      }
    ]
  },
  board: {
    uptitle: 'About',
    title: 'Advisory Board',
    content:
      'The Toronto Global Forum leadership team works closely with a select group of individuals who form our Advisory Board. All members of the Toronto Global Forum Advisory Board have been carefully selected for their in-depth knowledge and experience within their respective fields. '
  },
  boardIndex: {
    chairmens: {
      title: 'Chairman',
      index: [
        {
          name: 'John M. Beck',
          title: '',
          info: 'Founder and Chairman at Aecon & and Chairman of the Advisory Board at the Toronto Global Forum',
          image: '/images/boards/toronto/John-M-Beck.png'
        }
      ]
    },
    members: {
      title: 'Members',
      index: [
        {
          name: 'Bertrand Badré',
          info: 'Chief Executive Officer and Founder, Blue Orange Capital',
          image: '/images/boards/toronto/Bertrand-Badre.jpg'
        },
        {
          name: 'Dan Barclay',
          info: 'Chief Executive Officer & Group Head, BMO Capital Markets',
          image: '/images/boards/toronto/Barclay-Dan.png'
        },
        {
          name: 'Christiane Bergevin',
          info: 'President, Bergevin Capital and Past Chair of the Board, Canadian Chamber of Commerce',
          image: '/images/boards/toronto/Christiane-Bergevin.png'
        },
        {
          name: 'Stefanie Crosby',
          info: 'President and Chief Visionary Officer, Triumspear International',
          image: '/images/boards/toronto/Crosby-Stefanie.png'
        },
        {
          name: 'Janet De Silva',
          info: 'President and Chief Executive Officer, Toronto Region Board of Trade',
          image: '/images/boards/toronto/Janet-De-Silva.jpg'
        },
        {
          name: "Craig D'Souza",
          info:
            'Vice President of Global Security, Intelligence, Protective Intelligence, Investigations & Protective Services, Facebook',
          image: '/images/boards/toronto/Craig-DSouza.png'
        },
        {
          name: 'Mairead Lavery',
          info: 'President and Chief Executive Officer, Export Development Canada (EDC)',
          image: '/images/boards/toronto/Lavery-Mairead.png'
        },
        {
          name: 'Joseph S. Mancinelli',
          info:
            'International Vice President and Regional Manager of Central and Eastern Canada, Labourers International Union of North America (LiUNA)',
          image: '/images/boards/toronto/Joseph-S-Mancinelli.jpg'
        },
        {
          name: "Allan O'Dette",
          info: 'Canadian Business Leader and former Chief Executive Officer, Ontario Medical Association',
          image: '/images/boards/toronto/odette-allan-2016.png'
        },
        {
          name: 'Benoit Parent',
          info: 'Vice-President, Power Generation Business and Nuclear Operations, Cummins Sales and Service',
          image: '/images/boards/toronto/benoit-parent.jpg'
        },
        {
          name: 'Neil Pakey',
          info: 'President & CEO, Nieuport Aviation',
          image: '/images/boards/toronto/Neil_Packey.jpg'
        },
        {
          name: 'Lisa Raitt',
          info: 'Vice-Chair, Global Investment Banking, CIBC Capital Markets',
          image: '/images/boards/toronto/Raitt-Lisa.jpg'
        },
        {
          name: 'Nicholas Rémillard',
          info: 'Chief Executive Officer, International Economic Forum of the Americas (IEFA)',
          image: '/images/boards/toronto/Nicholas-Rémillard.jpg'
        },
        {
          name: 'Dimitri Soudas',
          info: 'Chairman, Letho Resources; Vice-President, Groupe Selection, Co-Founder Kids Inc',
          image: '/images/boards/toronto/Dimitri-Soudas.png'
        },
        {
          name: 'Jeffrey Steiner',
          info: 'Founder and Owner, New Franchise Media',
          image: '/images/boards/toronto/Jeffrey-Steiner.jpg'
        },
        {
          name: 'Kenneth Tanenbaum',
          info: 'Chairman, Kilmer Developments; and Vice-Chairman, Kilmer Van Nostrand (KVN)',
          image: '/images/boards/toronto/tanenbaum-ken.jpg'
        },
        {
          name: 'Douglas E. Turnbull',
          info: 'Vice-Chairman and Country Head, Canada',
          image: '/images/boards/toronto/turnbull-douglas-2016.jpg'
        },
        {
          name: 'Sonja Volpe',
          info: 'President and Chief Executive Officer, BNP Paribas Canada',
          image: '/images/boards/toronto/Volpe-Sonja.png'
        },
        {
          name: 'Geoffrey A. Wilson',
          info: 'Canadian Business Leader and former President and Chief Executive Officer, PortsToronto',
          image: '/images/boards/toronto/wilson-geoff.jpg'
        },
        {
          name: 'Paul Zed',
          info: 'National Counsel, McCarthy Tetrault',
          image: '/images/boards/toronto/zed-paul.png'
        }
      ]
    }
  }
}
